<template>
  <b-modal :id="dataId" centered size="lg" :title="dataTitle" :dataTags="dataTags" :dataText="dataText" @hidden="resetForm" hide-footer>
    <template #modal-header-close>
      <font-awesome-icon class="fa-fw" :icon="['fas', 'times']"/>
    </template>
    <div class="d-block text-left">
      <p>{{ sentence }}</p>
    </div>
    <div>
      <b-form @submit.prevent="onSubmit" novalidate>
        <b-form-row class="py-md-2 m-0">
          <div class="col-md-6 pl-0 pr-0 pr-md-2 py-md-0 py-2">
            <label for="first-name">First Name*</label>
            <b-form-input
              id="first-name"
              required
              :state="errors.firstName.state"
              @focus="clearInput('firstName')"
              v-model="form.firstName"
            ></b-form-input>
            <span v-if="errors.firstName.state === false" class="error-message">{{ errors.firstName.error }}</span>
          </div>
          <div class="col-md-6 pr-0 pl-0 pl-md-2 py-md-0 py-2">
            <label for="last-name">Last Name*</label>
            <b-form-input
              id="last-name"
              required
              :state="errors.lastName.state"
              @focus="clearInput('lastName')"
              v-model="form.lastName"
            ></b-form-input>
            <span v-if="errors.lastName.state === false" class="error-message">{{ errors.lastName.error }}</span>
          </div>
        </b-form-row>
        <b-form-row class="py-2 m-0">
          <label for="email">Email Address*</label>
          <b-form-input
            id="email"
            type="email"
            required
            :state="errors.email.state"
            @focus="clearInput('email')"
            lazy-formatter
            :formatter="formatter"
            v-model="form.email"
          ></b-form-input>
          <span v-if="errors.email.state === false && this.form.email.length <= 0" class="error-message">{{ errors.email.error1 }}</span>
          <span v-if="errors.email.state === false && this.form.email.length > 0" class="error-message">{{ errors.email.error2 }}</span>
        </b-form-row>
        <b-form-row class="py-2 m-0">
          <label for="message">Message*</label>
          <b-form-textarea
            id="message"
            size="lg"
            required
            :state="errors.message.state"
            @focus="clearInput('message')"
            v-model="form.message"
          ></b-form-textarea>
          <span v-if="errors.message.state === false" class="error-message">{{ errors.message.error }}</span>
        </b-form-row>
        <b-form-row class="py-2 m-0">
          <label for="phone-num">Phone Number (optional)</label>
          <b-form-input
            id="phone-num"
            v-model="form.phone"
            :state="errors.phone.state"
            @focus="clearInput('phone')"
          ></b-form-input>
          <span v-if="errors.phone.state === false" class="error-message">{{ errors.phone.error }}</span>
        </b-form-row>
        <div class="d-flex">
          <b-button type="submit" class="mt-4 mx-auto modal-btn">SUBMIT</b-button>
        </div>
      </b-form>
    </div>

  </b-modal>

</template>

<script>

import ContactService from '@/services/contact.service';

export default {
  name: 'formModal',
  props: {
    dataTitle: String,
    dataId: String,
    dataTags: Array,
    dataText: String,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        message: '',
        phone: '',
      },
      sentence: this.dataText,
      valid: false,
      errors: {
        firstName: {
          error: 'This field is required',
          state: null,
        },
        lastName: {
          error: 'This field is required',
          state: null,
        },
        email: {
          error1: 'This field is required',
          error2: 'Please enter a valid email',
          state: null,
        },
        phone: {
          error: 'Please enter a valid phone number',
          state: null,
        },
        message: {
          error: 'This field is required',
          state: null,
        },
      },
    };
  },
  computed: {
    validateFirstName() {
      return this.form.firstName.length > 0;
    },
    validateLastName() {
      return this.form.lastName.length > 0;
    },
    validateMessage() {
      return this.form.message.length > 0;
    },
    validateEmail() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.form.email).toLowerCase());
    },
    validatePhone() {
      var re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
      return re.test(String(this.form.phone));
    },
  },
  methods: {
    onSubmit() {
      this.errors.firstName.state = this.validateFirstName;

      this.errors.lastName.state = this.validateLastName;

      this.errors.email.state = this.validateEmail;

      this.errors.message.state = this.validateMessage;

      if(this.form.phone.length > 0) {
        this.errors.phone.state = this.validatePhone;
      }
      else {
        this.errors.phone.state = true;
      }

      if(this.errors.firstName.state === true && this.errors.lastName.state === true && this.errors.email.state === true && this.errors.phone.state === true && this.errors.message.state === true) {
        this.valid = true;
      }

      if(this.errors.firstName.state === true) {
        this.errors.firstName.state = null;
      }

      if(this.errors.lastName.state === true) {
        this.errors.lastName.state = null;
      }

      if(this.errors.email.state === true) {
        this.errors.email.state = null;
      }

      if(this.errors.phone.state === true) {
        this.errors.phone.state = null;
      }

      if(this.errors.message.state === true) {
        this.errors.message.state = null;
      }

      if(this.valid) {
        const params = {
          "firstname": this.form.firstName,
          "lastname": this.form.lastName,
          "phone": this.form.phone,
          "email": this.form.email,
          "comments": this.form.message,
          "tags": this.dataTags,
        };
        ContactService.create(params);
        this.$bvModal.hide(this.dataId);
        this.valid = false;
        this.form.firstName = '';
        this.form.lastName = '';
        this.form.email = '';
        this.form.message = '';
        this.form.phone = '';
      }
    },
    formatter(value) {
      return value.toLowerCase();
    },
    clearInput(key) {
      if (this.errors[key]) {
        this.errors[key].state = null;
      }
    },
    resetForm() {
      this.valid = false;
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.email = '';
      this.form.message = '';
      this.form.phone = '';
      this.errors.firstName.state = null;
      this.errors.lastName.state = null;
      this.errors.email.state = null;
      this.errors.phone.state = null;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  input:focus, textarea:focus {
    box-shadow: none;
  }
  textarea {
    font-size: 1rem !important;
    &.is-invalid {
      background-position-y: 50%;
    }
  }
  .error-message {
    font-size: 12px;
  }
  .is-invalid {
    box-shadow: inset 0px 0px 60px rgba(255, 99, 71, 0.6) !important;
  }

</style>
